<template>
    <div ref="drop_container">
        <div ref="drop_nav" class="navItem" @blur="SetDropStatus(false)"><em>{{text}}</em></div>
        <div ref="drop_box" class="dorpBox many">
            <div class="manyselect">
            <div class="item" v-for="(item,index) in options" :key="'muti_1_'+index">
                <div class="title">{{item.title}}<span>({{is_single?'可以选择一项':'可以选择多项'}})</span></div>
                <div class="navbox">
                    <template v-for="(item2,index2) in item.children">
                        <a @click="SelectItem(item2,item)" :key="'muti_2_'+index2" :class="{on:item2.selected}">{{item2.title}}</a>
                    </template>
                </div>
            </div>
            </div>
            <div class="btn">
                <a @click="Reset()" class="Clear">重置</a>
                <a @click="Confirm()" class="submit">确定</a>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    props:['value','title','options','is_single'],
    data(){return{
        text:'',
        val:[],
    }},
    created(){
        this.text=this.title;
        Array.prototype.indexOf = function(val) { //prototype 给数组添加属性
            for (var i = 0; i < this.length; i++) { //this是指向数组，this.length指的数组类元素的数量
                if (this[i] == val) return i; //数组中元素等于传入的参数，i是下标，如果存在，就将i返回
            }
            return -1; 
        };
        Array.prototype.remove = function(val) {  //prototype 给数组添加属性
            var index = this.indexOf(val); //调用index()函数获取查找的返回值
            if (index > -1) {
                this.splice(index, 1); //利用splice()函数删除指定元素，splice() 方法用于插入、删除或替换数组的元素
            }
        };
    },
    mounted(){
        var _this=this;
        $(_this.$refs.drop_container).hover(function() {
            _this.SetDropStatus(true);
        }, function() {
            _this.SetDropStatus(false);
        });
    },
    methods:{
        SelectItem(_item,_parent){
            // console.log('SelectItem');
            // console.log(_item);
            // console.log(_parent);
            var _this=this;
            if (this.is_single){
                if (_item.selected){   //当前是选中的
                    _this.$set(_item,"selected",false);
                    _this.val.remove(_item.id);
                    return;
                }
                _parent.children.map(function(obj){
                    if (obj.selected){
                        _this.$set(obj,"selected",false);
                        _this.val.remove(obj.id);
                    }
                });
            }
            if (_item.selected){
                this.$set(_item,"selected",false);
                this.val.remove(_item.id);
            }else{
                this.$set(_item,"selected",true);
                this.val.push(_item.id);
            }
        },
        SetDropStatus(_status){
            var _this=this;
            if (_status){
                $(_this.$refs.drop_box).stop(500).fadeIn('');
                $(_this.$refs.drop_nav).addClass('curr');
            }else{
                $(_this.$refs.drop_box).stop(500).fadeOut('');
                $(_this.$refs.drop_nav).removeClass('curr');
            }
        },
        Confirm(){
            this.$emit('input',this.val.join(","));
            this.SetDropStatus(false);
            this.NotifyTagChange();
        },
        NotifyTagChange(){
            var _this=this;
            //通知父组件更新选中标签
            var list_value=[];
            this.options.map(function(_item){
                var selected_value=[];
                _item.children.map(function(_item2){
                    if (_item2.selected){
                        selected_value.push(_item2.title);
                    }
                })
                if (selected_value.length>0){
                    list_value.push({title:_item.title,value:selected_value.join(','),type:_this.title,itemObj:_item,id:_item.id});
                }
            });
            this.$emit('valueChange',{title:this.title,list_value:list_value});
        },
        Reset(){
            var _this=this;
            this.val=[];
            this.options.map(function(_item){
                _item.children.map(function(_item2){
                    _this.$set(_item2,"selected",false);
                });
            });
        },
        CancelTag(_item){
            var _this=this;
            // console.log(_item);
            if (_item.type==this.title){
                if (_item.itemObj&&_item.itemObj.children){
                    _item.itemObj.children.map(function(_item2){
                        if (_item2.selected){
                            _this.SelectItem(_item2,_item.itemObj);
                        }
                    });
                    _this.Confirm();
                }
            }
        }
    },
}
</script>